export default "__VITE_ASSET__axZuNB0I__"